import React from 'react';
import EditIco from "../Images/edit-ico.svg";
import DeleteIco from "../Images/trash-ico.svg";
import ArrowLeft from "../Images/arrow-left-ico.svg";
import ArrowRight from "../Images/arrow-right-ico.svg";

export default function Datatable({column, data, action = false, pagination = {page: 1, sizePerPage: 10}}) {
    
    return (
        <div>
            <div className="table-common-info">
                <div className="table-responsive">
                    {data.length > 0 ? <table className="table">
                        <thead>
                            <tr>
                                {column.map((item, i) => <th key={i}>{item.replace("_", " ").toUpperCase()}</th>)}
                                {action && <th>Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.map(item => 
                                    <tr key={item["id"]}>
                                        {column.map(i => <td>{item[i]}</td>)}
                                        {action && <td>
                                            {action.includes(1) && <div className="text-center action-btns-tbl">
                                                <button type="button">
                                                    <img src={EditIco} className="mx-2" loading="lazy" alt="" />
                                                </button>
                                            </div>}
                                        </td>}
                                    </tr>
                                )
                            }
                        </tbody>
                    </table> : <p>Start uploading your advertise by clicking "Add New Advertisement" button</p>}
                </div>
            </div>
            <div className="table-common-ftr">
                <div className="row me-0">
                    <div className="col-md-6 pe-0">
                        <div className="d-md-inline-flex d-flex align-items-center btm-tbl-text">
                            <span className="me-2 d-block">Show rows</span>
                            <select className="form-select form-style-input">
                                {/* <option selected>Select items</option> */}
                                <option value={10} selected={pagination.sizePerPage === 10}>10</option>
                                <option value={20} selected={pagination.sizePerPage === 20}>20</option>
                                <option value={100} selected={pagination.sizePerPage === 50}>50</option>
                                <option value={100} selected={pagination.sizePerPage === 100}>100</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6 pe-0">
                        <div className="d-flex align-items-center justify-content-md-end justify-content-center pagination-style-tbl mt-3 mt-md-0">
                            <button type="button">
                                <img src={ArrowLeft} loading="lazy" alt="" />
                            </button>
                            <button type="button" className="active">1</button>
                            <button type="button">
                                2
                            </button>
                            <button type="button">3</button>
                            <button type="button">
                                <img src={ArrowRight} loading="lazy" alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}